import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "has-text-link has-text-weight-semibold" }
const _hoisted_2 = { class: "has-text-link has-text-weight-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_descriptions_item = _resolveComponent("n-descriptions-item")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_descriptions = _resolveComponent("n-descriptions")!

  return (_openBlock(), _createBlock(_component_n_descriptions, {
    hoverable: "",
    "label-placement": "top",
    title: _ctx.$t('preferences.my_account.title'),
    size: "large",
    column: 1
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_descriptions_item, null, {
        label: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('preferences.my_account.username')), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.user?.username), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_descriptions_item, null, {
        label: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('preferences.my_account.email')), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.user?.email), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_descriptions_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            quaternary: "",
            type: "error",
            onClick: _ctx.deleteAccount
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('preferences.my-account.delete_account')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}